import axios from '@/api/axios'

const getHeaders = () => {
    return {
        'ctl-device-id': localStorage.getItem('gzh-coach-userphone') || Date.now(),
        'app-type': 100
    }
}

/**
 * @name 教练端-教练分销首页，获取科目商品信息
 * @param res
 */
export const getCoachSubjectGoods = function (data) {
    return axios({
        url: `/exam/outer/coach/retail/v2/initMakePage`,
        method: 'POST',
        data
    })
}

/**
 * @name 公众号H5-获取商品信息列表
 * @param res
 */
export const getGzhH5GoodsItems = function (data) {
    return axios({
        url: `/exam/outer/coach/retail/v2/retailEntrance`,
        method: 'POST',
        data,
        headers: getHeaders()
    })
}

/**
 * @name 公众号H5-切换商品信息
 * @param res
 */
export const getGoodsDetail = function (data) {
    return axios({
        url: `/exam/outer/coach/retail/v2/switchGoods`,
        method: 'POST',
        data,
        headers: getHeaders()
    })
}

/**
 * @name 公众号H5-下单购买
 * @param res
 */
export const payGoods = function (data) {
    return axios({
        url: `/mall/outer/vipGoods/retail/payVipGoods`,
        method: 'POST',
        data,
        headers: getHeaders()
    })
}

/**
 * @name 公众号H5-获取微信支付配置信息
 * @param res
 */
export const getWxPayInfo = function (data) {
    return axios({
        url: `/mall/outer/vipGoods/retail/coachRetailPay`,
        method: 'POST',
        data,
        headers: getHeaders()
    })
}

/**
 * @name 公众号H5-获取微信支付配置信息
 * @param res
 */
export const getPaySuccess = function (data) {
    return axios({
        url: `/mall/outer/vipGoods/retail/paySuccess`,
        method: 'POST',
        data,
        headers: getHeaders()
    })
}
